import logo from './logo.svg';
import './App.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Screens/Home';
import Home2 from './Screens/Home2';
import CJPMemberCardSite from './Screens/buy-tshirt';

function App() {
  return (
    <div className="App">
      <BrowserRouter>

        <Routes>
          <Route index element={<Home2 />} />
 <Route path="buy" element={<CJPMemberCardSite />} />
        </Routes>
      </BrowserRouter></div>
  );
}

export default App;
